<template>
  <div class="popular-container">
    <h4 class="popular-title">Our most popular lessons</h4>

    <div class="four-cards-group">
      <b-card-group deck class="deck-cards">
        <b-card
          v-for="(product) in activeCards()"
          :key="product.id"
          :title="product.productTitle"
          :img-src="product.cardImage"
          img-alt="Step lessons image"
          img-top
          class="text-center shadow add-border-radius"
          id="productCard"
          ref="btnLiveQAShow"
          @click="updateQueryParams(product.category, product.id); stepContent(product); showModalOrOpenLink(product.hasModal, product.videoUrl);"
        >
          <b-card-text>
            {{ product.description }}
          </b-card-text>
        </b-card>
      </b-card-group>
    </div>


    <!-- MODAL LIVE QA -->
    <LiveQAModalComponent :step="step" :liveqaCardsData="liveqaCardsData"/>

    <!-- BUTTON -->
    <div class="button-see-more-box" v-if="!hiddenButton">
      <b-button
        pill
        variant="outline-dark"
        class="button-see-more"
        @click="loadMore"
        >See More</b-button
      >
    </div>
  </div>
</template>

<script>
import LiveQAModalComponent from '@/components/centre/liveqa/LiveQAModalComponent.vue';

export default {
  name: "LiveQAShowAllCards",
  components: {
    LiveQAModalComponent, 
  },
  props: ["liveqaCardsData", "step"],
  mounted() {
    if (this.$route.name === 'LiveQA' && this.$route.query.category) {
      this.activeCategory = this.$route.query.category;
    } else {
      this.activeCategory = 'ShowAll';
    }
    if (this.length > this.activeCards().length) {
      //hide button show more 
      this.hiddenButton = true;
    } else {
      //show button show more
      this.hiddenButton = false;
    }
  },
  updated() {
    if (this.length > this.activeCards().length) {
      //hide button show more 
      this.hiddenButton = true;
    } else {
      //show button show more
      this.hiddenButton = false;
    }
  },
  data() {
    return {
      activeCategory: 'ShowAll',
      length: 20,
      hiddenButton: false,
    };
  },
  computed: {
    // activeCards: function() {
    //   return this.liveqaCardsData.filter(function(u) {
    //     return u.showOnDeck;
    //   });
    // },
  },
  methods: {
    activeCards: function() {
      this.$root.$on("liveqa-category", (value) => {
        this.activeCategory = value;
        //to restart initial lenght in case the button show more was clicked
        this.length = 20;
      });
      if (this.activeCategory !== 'ShowAll') {
        return this.liveqaCardsData.filter((u) => {
          return u.category === this.activeCategory;
        }).slice(0, this.length);
      }
      return this.liveqaCardsData.slice(0, this.length);
    },
    loadMore() {
      if (this.length > this.liveqaCardsData.length) return;
      this.length = this.length + 4;
    },
    showModalOrOpenLink(hasModal, url) {
      console.log('Lets see what is going to be opened...');
      console.log('Modal: ' + hasModal);
      console.log('URL: ' + url);
      if(hasModal) {
        console.log('Ready to open the modal');
        this.$root.$emit('bv::show::modal', 'modal-liveqa', '#btnLiveQAShow');
      } else {
        if(url !== '') {
          //to open an external link instead of a modal
          console.log('Ready to open the external link');
          window.open(url, '_blank', 'noreferrer');
        }
      }
    },
    updateQueryParams(category, id) {
      this.$router.push({
        name: "LiveQA",
        query: { category: category, step: id },
      }).catch(()=>{});
    },
    stepContent(stepContent) {
      this.$root.$emit(
        "step-content",
        stepContent
      );
    },
  },
};
</script>

<style scoped lang="scss">
$light-gray: #e7e7e7;

.popular-title {
  font-weight: 700;
  margin: 3rem 0;
}

.four-cards-group {
  //margin-bottom: 4rem;
}

.deck-cards {
  display: flex;
  justify-content: flex-start;
  margin: auto;
}

div.card {
  border: none;
  cursor: pointer;
  //display: inline-block;
}

.card-img-top {
  //background-color: $light-gray;
}

h4.card-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.add-border-radius {
  border-radius: 1rem;
  //margin-left: 0;
  //margin-right: 0;
  min-width: 209.5px;
  max-width: 209.5px;
  margin: 1rem 1.25rem;

  //object-fit: cover;

  img {
    border-radius: 1rem 1rem 0 0;
    background-color: $light-gray;
    height: 220px;
  }
}

.button-see-more-box {
  display: flex;
  justify-content: center;
  margin-top: 3rem;

  button {
    font-weight: 700;
    &:hover {
      background-color: black;
    }
  }
}

/* Row Container */
.row {
  display: flex;
  flex-wrap: wrap;
}

/* In order to create four equal columns */
.column {
  flex: 25%;
  padding: 20px;
}

/* two columns */
@media screen and (max-width: 992px) {
  .column {
    flex: 50%;
  }

  .deck-cards.card-deck {
    justify-content: center;
  }
}

/* One column */
@media screen and (max-width: 600px) {
  .row {
    flex-direction: column;
  }
}

@media screen and (max-width: 768px) {
  .card-deck {
    margin-left: 0;
  }
}

@media screen and (max-width: 575px) {
  .four-cards-group {
    margin-bottom: 0;
  }

  .card-deck {
    display: block;
    text-align: -webkit-center;
  }

  .add-border-radius {
    margin-right: 1rem;
  }
}

@media screen and (max-width: 399px) {
  .card-deck {
    text-align: -webkit-center;
  }
}
</style>
